import { ApiSuccess } from "ui/Scripts/source/models/common/apiSuccess";
import { getApiCall, postApiCall } from "./tokenService";
import { UserPasswordChangePageData } from "../user/userPasswordChangePageData";

export const setCulture = (culture: string): Promise<ApiSuccess> => {
    return getApiCall("api/userpublic/setculture?id=" + culture, ApiSuccess);
};

// #region PasswordChange
export const requestPasswordChange = (obj: any): Promise<ApiSuccess> => {
    return postApiCall("api/userpublic/requestpasswordchange", ApiSuccess, JSON.stringify(obj));
};

export const getUserPasswordChangePageData = (token: string): Promise<UserPasswordChangePageData> => {
    return getApiCall("api/userpublic/passwordchange?id=" + token, UserPasswordChangePageData);
};

export const saveUserPassword = (obj: any): Promise<ApiSuccess> => {
    return postApiCall("api/userpublic/savepassword", ApiSuccess, JSON.stringify(obj));
};
// #endregion PasswordChange
